(() => {
  let busy = false;
  let currentPath = location.pathname;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[data-ib-style]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    if (busy || link.getAttribute('aria-current') === 'true') return;
    const nav = link.closest('.ib-collection-refine');
    const section = nav.closest('.shopify-section');
    const target = new URL(link.href);
    const query = new URLSearchParams(location.search);
    query.delete('page'); query.delete('section_id');
    target.search = query.toString();
    busy = true;
    section.setAttribute('aria-busy', 'true');
    section.classList.add('ib-filter-loading');
    nav.querySelector('[data-ib-style-status]').textContent = 'Updating styles…';
    const top = nav.getBoundingClientRect().top;
    try {
      const response = await fetch(target.href);
      if (!response.ok) throw new Error('Style unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = parsed.getElementById(section.id);
      if (!replacement?.querySelector('#ProductGridContainer')) throw new Error('Missing results');
      replacement.querySelectorAll('.scroll-trigger').forEach(el => el.classList.remove('scroll-trigger', 'animate--slide-in'));
      section.replaceWith(replacement);
      history.pushState({searchParams: target.search.slice(1)}, '', target.href);
      currentPath = target.pathname;
      if (typeof FacetFiltersForm !== 'undefined') {
        FacetFiltersForm.filterData = [];
        FacetFiltersForm.searchParamsPrev = target.search.slice(1);
      }
      const newNav = replacement.querySelector('.ib-collection-refine');
      window.scrollBy({top: newNav.getBoundingClientRect().top - top, behavior: 'instant'});
      newNav.querySelector(`[data-ib-style][aria-current="true"]`)?.focus({preventScroll:true});
      newNav.querySelector('[data-ib-style-status]').textContent = 'Style updated.';
      replacement.classList.add('ib-filter-updated');
    } catch (error) {
      location.assign(target.href);
    } finally { busy = false; section.removeAttribute('aria-busy'); section.classList.remove('ib-filter-loading'); }
  });
  window.addEventListener('popstate', event => {
    if (location.pathname !== currentPath && document.querySelector('.ib-collection-refine')) {
      event.stopImmediatePropagation(); location.reload();
    }
  });
})();
